
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mahashivratri/significance-of-mahashivratri",
      function () {
        return require("private-next-pages/mahashivratri/significance-of-mahashivratri/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mahashivratri/significance-of-mahashivratri"])
      });
    }
  